<template>
  <section class="app-transporte">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12 sm12 xs12>
          <v-card outlined class="app-card">
            <v-card-title class="app-card-title">
              Acessar - Transportes
              <v-btn small outlined color="primary" v-on:click="voltar()" class="btn-voltar">Voltar</v-btn>
            </v-card-title>
            <v-card-text class="app-card-content">
              <v-alert
                text
                type="info"
                outlined
                icon="error_outline"
                prominent
              >Caso queira alterar seu e-mail, favor entrar em contato com a Arce.</v-alert>
              <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                <v-row>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="formattedCnpj"
                      placeholder="Digite o CNPJ/CPF da transportadora"
                      label="CNPJ/CPF Transportadora *"
                      :rules="[rules.required, rules.documento]"
                      maxlength="18"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <v-text-field
                      v-model="form.email"
                      placeholder="Digite o Email da transportadora"
                      label="Email *"
                      :rules="[rules.required, rules.email]"
                      filled
                      rounded
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col :md="12" :sm="12" :xs="12" cols="12">
                    <label class="ml-1">
                      <strong>Selecione o serviço fornecido pela transportadora</strong>
                    </label>
                    <v-radio-group v-model="form.servico" :rules="[rules.required]">
                      <v-row>
                        <v-radio
                          v-for="servico in servicos"
                          :key="servico.key"
                          :label="servico.name"
                          :value="servico.key"
                          class="mx-3"
                        ></v-radio>
                      </v-row>
                    </v-radio-group>
                  </v-col>
                  <v-col :md="9" :sm="9" :xs="12" cols="12">
                    <vue-recaptcha
                      ref="recaptcha"
                      :sitekey="siteKey"
                      :loadRecaptchaScript="true"
                      @verify="verifyRecaptcha"
                      @expired="expiredRecaptcha"
                      class="recaptcha"
                    ></vue-recaptcha>
                    <v-input v-model="form.recaptcha" :rules="[rules.required]"></v-input>
                  </v-col>
                  <v-col :md="3" :sm="3" :xs="12" cols="12">
                    <v-btn depressed block large color="primary" type="submit">Resetar</v-btn>
                  </v-col>
                </v-row>
              </v-form>
              <div class="loading" v-if="isLoading">
                <v-progress-circular :size="25" color="primary" indeterminate></v-progress-circular>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>

<script>
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import TransportadoraAuthAuthService from "@/services/transportadora.auth.service";
import GlobalStore from "@/store/modules/global";
import {
  detectTipoPessoa,
  formatDocumentoInput,
  normalizeDocumentoInput,
  validateDocumentoInput
} from "@/helpers/documento-identificacao.helper";

export default {
  components: {
    VueRecaptcha
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoading: false,
      form: {
        cnpj: null,
        email: null,
        recaptcha: null,
        servico: null
      },
      servicos: [
        { key: 1, name: "Regular" },
        { key: 2, name: "Complementar" },
        { key: 3, name: "Fretamento" }
      ],
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "E-mail inválido.";
        },
        required: value => !!value || "Esse campo deve ser preenchido",
        documento: value =>
          validateDocumentoInput(value, detectTipoPessoa(value)) ||
          "CNPJ/CPF inválido"
      }
    };
  },
  computed: {
    formattedCnpj: {
      get() {
        return this.form.cnpj;
      },
      set(value) {
        this.form.cnpj = formatDocumentoInput(value, detectTipoPessoa(value));
      }
    }
  },
  methods: {
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.form.recaptcha = null;
    },
    onSubmit() {
      const isValid = this.$refs.form.validate();

      if (isValid) {
        this.isLoading = true;
        let { cnpj, email, recaptcha, servico } = this.form;
        cnpj = normalizeDocumentoInput(cnpj, detectTipoPessoa(cnpj));
        const { returnUrl } = this.$route.query;
        TransportadoraAuthAuthService.resetarToken(
          cnpj,
          email,
          recaptcha,
          servico
        ).subscribe(
          response => {
            this.isLoading = false;
            GlobalStore.setSnackBar({
              show: true,
              message: "Senha resetada. Verifique o e-mail",
              type: "success"
            });
            this.voltar();
          },
          error => {
            this.expiredRecaptcha();
            this.isLoading = false;
            GlobalStore.setSnackBar({
              show: true,
              message: error,
              type: "error"
            });
          }
        );
      }
    },
    voltar() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn-voltar {
  position: absolute;
  right: 20px;
}
</style>
